export function getInitialStateMain() {
   return {
      tipoDocumento: [
         { label: 'CUIT', value: 'cuit' },
         // { label: 'DNI', value: 'dni' },
      ],
      condicionFiscal: [],
      entidad: [],
      descuento: [],
      payMethods: [],
      estados: [],
      moneda: [],
      partidos: [],
      productos: [],
      provincias: [],
      departamentos: {},
      localidades: {},
      secciones: [],
      paymentCia: [],
      sponsors: [],
      sucursales: [],
      usuarios: [],
      sections: null, // null = aún no cargaron; [] = cargaron y están vacías
      companyIconBase64: null,
      companyIconBlob: null,
      isLoading: true,
      monedas: [],
      cultivos: [],
      empresasGrupo: [],
      sucursalesEmpresa: [],
   };
}

export default getInitialStateMain();
